import Box from 'UIKit/Box/Box'
import Link from 'UIKit/Link'
import Text from 'UIKit/Text'
import React, { useState, useCallback } from 'react'
import styled from 'styled-components'
import { Icons } from 'svgs'
import hunnyTheme from 'theme'
import { Trans } from 'react-i18next'
import { RowBetween } from '../Row'

type DetailMenu = {
  content?: string | any
  to?: string
  onClick?: () => void
  isExternal?: boolean
  id?: string
  attributes?: {
    rel?: string
  }
}

type MenuExpandProps = {
  menu: DetailMenu
  subMenus: DetailMenu[]
  menuHeight: number
}

const MenuFooterExpand: React.FC<MenuExpandProps> = ({ menu, subMenus, menuHeight }) => {
  const [isOpen, setIsOpen] = useState(false)

  const handleToggle = useCallback(() => setIsOpen(!isOpen), [isOpen])

  return (
    <Box>
      <StyledLinkParentItem onClick={handleToggle} height={menuHeight}>
        <RowBetween>
          <Text width="max-content" color={hunnyTheme.colors.text} fontSize="12px" fontWeight="bold">
            <Trans>{menu.content}</Trans>
          </Text>
          <StyledExpandMoreIcon $open={isOpen} />
        </RowBetween>
      </StyledLinkParentItem>

      <StyledLinkSubItemContainer style={isOpen ? { maxHeight: (subMenus.length + 1) * menuHeight } : { maxHeight: 0 }}>
        {subMenus.map((item, index) => {
          return (
            <StyledLinkSubItem
              id={item.id}
              key={`${item.content}-${index}-${menu.id}`}
              href={item.to || '#'}
              height={menuHeight}
              external={item.isExternal}
              {...(item?.attributes || {})}
            >
              <Text color="textSubtle" fontSize="12px">
                <Trans>{item.content}</Trans>
              </Text>
            </StyledLinkSubItem>
          )
        })}
      </StyledLinkSubItemContainer>
    </Box>
  )
}

const StyledLinkParentItem = styled(Box)`
  margin: 4px 0px;
  position: relative;
  display: flex;
  color: ${(props) => props.theme.colors.textSubtle};
  box-sizing: border-box;
  align-items: center;
  cursor: pointer;
  justify-content: start;
  text-decoration: none;
  border-radius: 8px;
`

const StyledExpandMoreIcon = styled(Icons.ArrowDownIcon)<{ $open: boolean }>`
  fill: ${(props) => props.theme.colors.text};
  transition: transform ${({ theme }) => theme.transitions.medium};

  ${({ $open }) =>
    $open
      ? `
        transform: rotate(180deg);
        `
      : `
        transform: rotate(360deg);
      `}
`

const StyledLinkSubItemContainer = styled.div`
  margin-top: 2px;
  transition: max-height ${({ theme }) => theme.transitions.medium} ease-out 0s;
  overflow: hidden;
  border-radius: ${({ theme }) => theme.radii.default};
`

const StyledLinkSubItem = styled(Link)`
  padding: 5px 16px;
  max-height: 45px;
  display: flex;
  align-items: center;
`

export default MenuFooterExpand
